export { default as FocusTrap } from './FocusTrap';
export type { Props as FocusTrapProps } from './FocusTrap';
export { default as withFocusTrap } from './withFocusTrap';
